module.exports = __webpack_public_path__ + "static/media/saeed.006def9b.png";